<template>
  <div>
    <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="{span:3}" :wrapper-col="wrapperCol">
      <a-form-item :wrapper-col="{offset:3}">
        <a-checkbox v-model:checked="form.is_set_out_warehousing_time" disabled>发货时间</a-checkbox>
        <a-checkbox v-model:checked="form.is_set_receiving_dealer">收货经销商</a-checkbox>
        <a-checkbox v-model:checked="form.is_set_receiving_store">收货门店</a-checkbox> 
        <a-checkbox v-model:checked="form.is_set_receiving_product">出货商品</a-checkbox>
      </a-form-item>
      <a-form-item label="发货时间" :rules="[{ required: true, message: '请选择发货时间' }]" v-if="form.is_set_out_warehousing_time">
        <a-range-picker valueFormat='YYYY-MM-DD' format="YYYY-MM-DD" v-model:value="timer" @change="changeTime" />
      </a-form-item>
      <a-form-item label="收货经销商" name="dealer_info" :rules="[{ required: true, message: '请选择收货经销商' }]" v-if="form.is_set_receiving_dealer">
        <a-button @click="showDealer=true">选择</a-button>
        <a-button type="link" @click="checkDetail('dealer')">已选明细</a-button>
      </a-form-item>
      <a-form-item label="收货门店" name="store_info" :rules="[{ required: true, message: '请选择收货门店' }]" v-if="form.is_set_receiving_store">
        <a-button @click="showStore=true">选择</a-button>
        <a-button type="link" @click="checkDetail('store')">已选明细</a-button>
      </a-form-item>
      <a-form-item label="出货商品" name="product_info" :rules="[{ required: true, message: '请选择出货商品' }]" v-if="form.is_set_receiving_product">
        <a-button @click="showGoods=true">选择</a-button>
        <a-button type="link" @click="checkDetail('goods')">已选明细</a-button>
      </a-form-item>
      <a-form-item>
        <SmallSquare content="1、首次添加后，系统会每天凌晨12点根据设置的出货条件从智能物流系统中自动读取更新符合条件的码，再根据设置手动或自动把符合条件的码添加到码范围中；
2、同时满足所勾选的条件系统才会进行读取；
3、每次保存，会根据最新设置的条件重新进行条件组合。
4、同时选择收货经销商和收货门店，只需满足经销商或门店要求即可参与活动" />
      </a-form-item>
      <a-form-item :wrapper-col="{offset:3}">
        <a-button @click="cancel" class="m-r-10">取消</a-button>
        <a-button @click="submit" type="primary" :loading="loading">确定</a-button>
      </a-form-item>

    </a-form>
  </div>
  <!-- 选择经销商 -->
  <a-modal :keyboard="false" title="选择经销商" centered v-model:visible="showDealer" :width='1200' :footer="null" destroyOnClose>
    <selectDealer :checkout='true' :mustShowHeadquarters="false" v-on:select="dealerSelect" :selectList='form.dealer_info' />
  </a-modal>
  <!-- 选择门店 -->
  <a-modal :keyboard="false" title="选择门店" centered v-model:visible="showStore" :width='1200' :footer="null" destroyOnClose>
    <selectStore :checkout='true' :hiddenHead="true" v-on:select="storeSelect" :selectList='form.store_info' />
  </a-modal>
  <!-- 出货商品 -->
  <a-modal :keyboard="false" title="选择商品" centered v-model:visible="showGoods" :width='1200' :footer="null" destroyOnClose>
    <selectGood :checkout='true' v-on:select="goodsSelect" :selectList='form.product_info' :skuType="true"/>
  </a-modal>
  <a-modal :keyboard="false" title="已选明细" centered v-model:visible="showDetail" :width='1200' :footer="null" destroyOnClose>
    <a-table bordered :columns='columns' :data-source='list'>
      <template v-slot:info="{record}">
        <a-card-meta>
          <template #avatar>
            <img :src="info.picdomain+(record.product_image||record.cover_image_url)" alt="" style="width:50px;height: 50px;object-fit:cover">
          </template>
          <template #description>{{record.product_name}}</template>
        </a-card-meta>
      </template>
      <template v-slot:category="{ record }">
        <p v-if='record.category_name'>{{record.category_name || '未分类'}}</p>
        <p v-else>{{record.category.name || '未分类'}}</p>
      </template>
      <template v-slot:action="{ index }">
        <a-button type="primary" @click='del(index)'>删除</a-button>
      </template>
    </a-table>
  </a-modal>
</template>
<script>
import { reactive, ref, toRefs } from "@vue/reactivity";
import {
  store_matching_condition_to_range,
  show_range_info,
  update_matching_condition_to_range,
  
} from "@/api/guide";
import store from "@/store";
import { iscode } from "@/utils/app";
import { onMounted } from "@vue/runtime-core";
export default {
  props: {
    activity_id: String,
    is_edit:{
      type:String,
      default:()=>{
        return null
      }
    },
  },
  setup(props, { emit }) {
    const form = ref({
      activity_id: props.activity_id,
      is_set_out_warehousing_time: true, //是否指定出货时间
      is_set_receiving_dealer: false, //是否指定收货经销商
      is_set_receiving_store: false, //是否指定收货门店
      is_set_receiving_product: false, //是否指定出货商品
      time_info: {
        start_time: null, //开始时间
        end_time: null, //结束时间
      },
      store_info: [],
      dealer_info: [],
      product_info: [],
    });
    const timer = ref();
    const modalVisible = reactive({
      showDealer: false,
      showDetail: false,
      showStore: false,
      showGoods: false,
    });
    const changeTime = (e) => {
      form.value.time_info.start_time = e[0];
      form.value.time_info.end_time = e[1];
    };
    // 选择经销商
    const dealerSelect = (data) => {
      form.value.dealer_info = data;
      modalVisible.showDealer = false;
    };
    // 选择门店
    const storeSelect = (data) => {
      form.value.store_info = data;
      modalVisible.showStore = false;
    };
    // 选择出货商品
    const goodsSelect = (data) => {
      form.value.product_info = data;
      modalVisible.showGoods = false;
    };
    // 已选明细
    const columns = ref([]);
    // 已选明细数据
    const list = ref([]);
    // 查看已选明细
    const checkDetail = (type) => {
      switch (type) {
        case "dealer":
          columns.value = [
            {
              title: "经销商编号",
              dataIndex: "dealer_sn",
              key: "dealer_sn",
            },
            {
              title: "经销商名称",
              dataIndex: "dealer_name",
              key: "dealer_name",
            },
            {
              title: "经销商级别",
              dataIndex: "level_name",
              key: "level_name",
            },
            {
              title: "负责人",
              dataIndex: "leader_name",
              key: "leader_name",
            },
            {
              title: "手机号码",
              dataIndex: "leader_phone",
              key: "leader_phone",
            },
            {
              title: "操作",
              key: "action",
              slots: { customRender: "action" },
            },
          ];
          list.value = form.value.dealer_info;
          modalVisible.showDetail = true;
          break;
        case "store":
          columns.value = [
            {
              title: "门店编号",
              dataIndex: "store_code",
              key: "store_code",
            },
            {
              title: "门店名称",
              dataIndex: "store_name",
              key: "store_name",
            },
            {
              title: "门店类型",
              dataIndex: "type_name",
              key: "type_name",
            },
            {
              title: "负责人",
              dataIndex: "clerk_name",
              key: "clerk_name",
            },
            {
              title: "手机号码",
              dataIndex: "clerk_phone",
              key: "clerk_phone",
            },
            {
              title: "操作",
              key: "action",
              width: 120,
              slots: { customRender: "action" },
            },
          ];
          list.value = form.value.store_info;
          modalVisible.showDetail = true;
          break;
        case "goods":
          columns.value = [
            {
              title: "ID",
              dataIndex: "id",
              key: "id",
            },

            {
              title: "商品信息",
              dataIndex: "info",
              key: "info",
              slots: { customRender: "info" },
            },
            {
            title: "规格",
            dataIndex: "product_sku_name",
            key: "product_sku_name",
            customRender:({record})=>{
              return record.product_sku_name ? record.product_sku_name:'单规格'
            } 
          },
            {
              title: "产品库分类",
              dataIndex: "category",
              key: "category",
              slots: { customRender: "category" },
            },
            {
              title: "价格/元",
              dataIndex: "product_price",
              key: "product_price",
            },
            {
              title: "操作",
              key: "action",
              width: 120,
              slots: { customRender: "action" },
            },
          ];
          list.value = form.value.product_info;
          modalVisible.showDetail = true;
          break;
      }
    };
    // 删除
    const del = (index) => {
      list.value.splice(index, 1);
    };
    const cancel = () => {
      emit("success");
    };
    const loading = ref(false);
    const submit = async () => {
      form.value.is_set_out_warehousing_time = form.value.is_set_out_warehousing_time
        ? 1
        : 0;
      form.value.is_set_receiving_dealer = form.value.is_set_receiving_dealer
        ? 1
        : 0;
      form.value.is_set_receiving_store = form.value.is_set_receiving_store
        ? 1
        : 0;
      form.value.is_set_receiving_product = form.value.is_set_receiving_product
        ? 1
        : 0;
      loading.value = true;
      let result;
      if (!props.is_edit) {
        result = await store_matching_condition_to_range({
          activity_id: props.activity_id,
          ...form.value,
        })
          .then((res) => res.data)
          .catch((error) => error);
      } else {
        result = await update_matching_condition_to_range({
          activity_id: props.activity_id,
          ...form.value,
          range_id:props.is_edit
        })
          .then((res) => res.data)
          .catch((error) => error);
      }

      loading.value = false;
      if (iscode(result, true)) {
        emit("success");
      }
    };
    const detail = async () => {
      let result = await show_range_info(props.is_edit)
        .then((res) => res.data)
        .catch((error) => error);
      form.value = result.data;
      timer.value = [
        result.data.time_info.start_time,
        result.data.time_info.end_time,
      ];
    };
    onMounted(() => {
      if(props.is_edit){
        detail();
      }
    });
    return {
      form,
      timer,
      ...toRefs(modalVisible),
      dealerSelect,
      columns,
      list,
      changeTime,
      checkDetail,
      storeSelect,
      goodsSelect,
      del,
      info: store.state.user.info,
      cancel,
      submit,
      loading,
    };
  },
};
</script>